export default __webpack_public_path__ + "static/media/home.b6bbe35e.png";